const ServerAddress = "https://dev.api.fin.cp.optimops.io";
// const ServerAddress = "https://api.fin.cp.optimops.io";
// const ServerAddress = "http://192.168.1.71:7777";
// const ServerAddress = "http://localhost:7777";

export default ServerAddress;